import type { SupportedRenderCard } from '../../../insightRenderShapes'
import { Answer, Note } from '../InsightsBlocks'
import { formatInsightDatum } from './formatInsightDatum'

export function MetricCard({ card }: { card: Extract<SupportedRenderCard, { kind: 'metric' }> }) {
  const strongLabel = card.emphasis === 'primary'
  return (
    <s-stack gap="small-200">
      <Answer figure={formatInsightDatum(card.datum)} label={card.datum.label} strongLabel={strongLabel} />
      {card.values?.map((datum, index) => (
        <Note key={index}>
          {datum.label}: {formatInsightDatum(datum)}
        </Note>
      ))}
    </s-stack>
  )
}
